import qs from 'qs';
import { useMutation, useQueryClient } from 'react-query';
import { useDispatch } from 'react-redux';
import { authFetch } from '../../../CommonUtils/authFetch';
import { dateToISO8601 } from '../../helpers/dates';
import { fetchOrionAccountsData } from '../../../ContextualSidebar/NetWorthSidebar/NetWorthSidebarActions';
import { QueryFeature } from '../../../../config/queryClient';

interface Params {
  clientId: string;
  accountId: string;
  groupId: string;
}

const refresh = ({ clientId, accountId, groupId }: Params) => {
  return authFetch(
    `/Consumer/OrionAccountsWidgets/Refresh${qs.stringify(
      {
        clientId,
        accountId: accountId || null,
        groupId: groupId || null,
        localDate: dateToISO8601(),
      },
      { skipNulls: true, addQueryPrefix: true },
    )}`,
    {
      method: 'POST',
    },
  );
};

interface MutationParams {
  clientId: string;
}

export const useRefreshMutation = ({ clientId }: MutationParams) => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  return useMutation(refresh, {
    async onSuccess() {
      dispatch(fetchOrionAccountsData(clientId));

      await queryClient.invalidateQueries(QueryFeature.AccountPerformanceReporting);
    },
  });
};
